import AlertWidget from '../../../lib/Alert/Alert';
import CardViewComponent from '../../../lib/CardViewComponent/CardViewComponent';
import Paginator from '../../../lib/Paginator/Paginator';
import PopupTableModel from '../../../lib/PopupTableModel/popupTableModel';
import {PAST_DUE_PAGE_SIZE} from '../../../utils/constant';
import {
  callNumber,
  dateFormatter,
  formatCurrency,
  paymentRemainDays,
} from '../../../utils/util';
import ContactPopupModal from '../../contact/popupModel/contactPopupModel';
import SkeletonLoader from '../../skeletonLoader/SkeletonLoader';

import {
  Box,
  Button,
  Card,
  CardContent,
  Typography,
  Link,
} from '@deere/fuel-react';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {connect} from 'react-redux';
import './pastDue.css';

const PastDue = (props) => {
  const {t} = useTranslation();
  const [modelVisible, setModelVisible] = React.useState(false);
  const [callBackVisible, setCallBackVisible] = React.useState(false);
  const [isNextInstallmentDue, setIsNextInstallmentDue] = React.useState(true);
  const [paginationReset, setPaginationReset] = React.useState(false);
  const [startIndex, setStartIndex] = React.useState(0);

  const pageSize = PAST_DUE_PAGE_SIZE;

  React.useEffect(() => {
    if (
      props.nextInstallmentDue &&
      Object.keys(props.nextInstallmentDue).length === 0
    ) {
      setIsNextInstallmentDue(false);
    }
  }, [props.nextInstallmentDue]);

  const renderRemainingDays = (dueDate) => {
    let remainingDay = paymentRemainDays(dueDate);
    return remainingDay === 0 ? '' : remainingDay * -1 + ' ' + t('DAYS_LATE');
  };
  const pastDueObj = props?.pastDue?.summary?.map((element) => {
    let item = {
      CONTRACT: {
        label: t('CONTRACT'),
        value: element.contract ?? 'NA',
      },

      AMOUNT_DUE: {
        label: t('AMOUNT_DUE'),
        value:
          (element.outstandingPaymentAmount &&
            formatCurrency(element.outstandingPaymentAmount)) ??
          'NA',
      },

      OUTSTANDING_DUE_DATE: {
        label: t('OUTSTANDING_DUE_DATE'),
        value:
          (element.paymentDueDate && dateFormatter(element.paymentDueDate)) ??
          'NA',
      },

      DAYS_LATE: {
        label: t('DAYS_LATE'),
        value:
          (element.paymentDueDate &&
            renderRemainingDays(element.paymentDueDate)) ??
          'NA',
      },
    };
    return item;
  });
  const CallMeElement = () => {
    return (
      <div className="callBackWrapper">
        <div className="callBackTitle">{t('PAST_DUE_CALL_BACK')}</div>
        <div className="callBackButtons">
          <Button
            id="callMeBackBtn"
            variant="secondary"
            onClick={() => setCallBackVisible(true)}
          >
            {t('CALL_ME_BACK')}
          </Button>
          <Button
            variant="primary"
            onClick={() => callNumber(t('CONTACT_NUMBER'))}
          >
            <Link href={`tel:${t('CONTACT_NUMBER')}`} id="contact-primaryBtn">
              {t('CALL_NOW')}
            </Link>
          </Button>
        </div>
      </div>
    );
  };
  return (
    <>
      {props.paymentScheduleLoader ? (
        <SkeletonLoader componentName="nextInstallment" />
      ) : props?.pastDue?.pastDue > 0 ? (
        <div>
          <Box>
            <Card id="pastDueCustomCard">
              <div className="pastDueContentWrapper">
                <div className="pastDueData">
                  <CardContent className="cardContentCustomPastDue">
                    <Typography className="pastDueSubTitle">
                      {t('PAST_DUE')}
                    </Typography>
                    <Typography className="pastDueAmount">
                      {formatCurrency(props?.pastDue?.pastDue)}
                    </Typography>
                  </CardContent>
                  <CardContent className="cardContentCustomPastDue">
                    <Typography className="pastDueSubTitle right-align">
                      {t('DUE_DATE')}
                    </Typography>
                    <Typography className="paymentDueDate right-align">
                      {dateFormatter(Date.now())}
                    </Typography>
                  </CardContent>
                </div>
                {isNextInstallmentDue && (
                  <Button
                    type="submit"
                    disabled={false}
                    id="viewSummaryButton"
                    variant="secondary"
                    onClick={() => setModelVisible(true)}
                  >
                    {t('VIEW_SUMMARY')}
                  </Button>
                )}
              </div>
              <AlertWidget
                type="warning"
                title=""
                content="PAST_DUE_WARNING"
                isClosable={false}
              />
              {!isNextInstallmentDue && (
                <div className={'pastDueComponent'}>
                  <div className={'pastDueTitle'}>{t('PAST_DUE_SUMMARY')}</div>
                  <CallMeElement />
                  {pastDueObj &&
                    pastDueObj.length > 0 &&
                    pastDueObj
                      .slice(startIndex, startIndex + pageSize)
                      .map((item, index) => (
                        <CardViewComponent
                          key={'card-component' + item.CONTRACT.value}
                          records={item}
                        />
                      ))}
                  {pastDueObj && pastDueObj.length >= pageSize && (
                    <Paginator
                      elementCount={pastDueObj?.length}
                      pageSize={pageSize}
                      reset={paginationReset}
                      onPaginationReset={() => setPaginationReset(false)}
                      onPageChange={(currentIndex) => {
                        setStartIndex(currentIndex);
                      }}
                    />
                  )}
                </div>
              )}
            </Card>
          </Box>
          <PopupTableModel
            title={t('PAST_DUE_SUMMARY')}
            visible={modelVisible}
            setVisible={setModelVisible}
            records={pastDueObj}
            secondaryElement={<CallMeElement />}
          />
          <ContactPopupModal
            id="ContactPopupModal"
            title={''}
            visible={callBackVisible}
            setVisible={setCallBackVisible}
          />
        </div>
      ) : (
        ''
      )}
    </>
  );
};

export const mapStateToProps = (state) => {
  return {
    pastDue: state.appStates?.paymentSchedule?.pastDue,
    paymentScheduleLoader: state.appStates.paymentScheduleLoader,
    nextInstallmentDue:
      state.appStates.paymentSchedule?.paymentSchedules?.nextInstallment,
  };
};
export default connect(mapStateToProps)(PastDue);
